import { Stack, StackProps, styled } from "@mui/material";
import { Star } from "lucide-react";

export const CtaOverlayContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  bottom: "1.5rem",
  flexDirection: "row",
  height: "2.5rem",
  // overflow: "hidden",
  position: "absolute",
  right: "2.5rem",
  zIndex: 9999,
  ".button":{
    borderRight: `2px solid ${theme.customColors.textPrimary}`
  },
  ".button:last-child":{
    borderRight: "none" 
  }
}));

export const StarsBoxContainer = styled(Stack)<
  StackProps & {
    $visibility?: boolean
  }
>(({ $visibility=false, theme }) => ({
  alignItems: "center",
  background: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "row", 
  // flexDirection: "row", 
  gap: "0.7rem",
  height: "2.5rem",
  justifyContent:"center",
  left: "50%",
  padding: "0.78rem",
  position: "absolute",
  top: $visibility ? "-0.5rem" : "0.5rem",
  opacity: $visibility ? 1 : 0,
  transform: "translate(-50%, -100%)",
  transition: "all 0.2s ease-out"
}));





export const StarIcon = styled(Star)(() => ({
  // margin: "0.125rem 0.5rem",
  cursor: "pointer",
  transition: "all 0.15s"
  // stroke:theme.customColors.systemSecondary01
  // background: index 
  // ":hover": {
  //   stroke:theme.customColors.systemSecondary01
  // }
  // "&:hover ~ .star-icon": {
  //   stroke:theme.customColors.systemSecondary01
  //   // fill:theme.customColors.systemSecondary01
    
  // }
}));
